/* eslint-disable react/prop-types */
import React from 'react';
// components
import { FormattedMessage } from 'react-intl';
import { CustomColumn } from 'components/DataTable/Columns/index';

// Column for the "Errors" tab: why the row was not imported.
// `error` is the backend error code; codes without their own message fall back to "Invalid data"
const renderErrorColumn = (knownErrors) => ({ error, error_details }) => {
  const code = knownErrors.includes(error) ? error : 'invalid';
  return (
    <CustomColumn label={<FormattedMessage id="component.csv.rowError.header" />} className="highlighted">
      <FormattedMessage id={`component.csv.rowError.${code}`} />
      {error_details && <span>&nbsp;({error_details})</span>}
    </CustomColumn>
  );
};

const errorColumn = (knownErrors = []) => ({
  label: <FormattedMessage id="component.csv.rowError.header" />,
  flex: '1 1 200px',
  renderer: renderErrorColumn(knownErrors),
  sortKey: 'error',
});

export default errorColumn;
